import { FC } from 'react'
import { IAppeal } from 'feature/lkmAppeals/types'
import { LkmAppeal } from '../lkmAppeal/LkmAppeal'

import styles from './LkmAppealsList.module.scss'
import { Button } from 'ui'
import { LoaderInCentalPosition } from 'widget'
import { CircularProgress } from '@mui/material'
import { EmptyInformationBlock } from 'widget/EmptyInformationBlock/EmptyInformationBlock'
import { Message } from '@mui/icons-material'

type LkmAppealsListProps = {
  appealsList: IAppeal[] | []
  setNextPage: () => void
  totalCount: number
  isFetching: boolean
  currentPage: number
  onOpen: (item: IAppeal) => void
}

export const LkmAppealsList: FC<LkmAppealsListProps> = ({
  appealsList,
  setNextPage,
  totalCount,
  isFetching,
  currentPage,
  onOpen,
}) => {
  if (isFetching && currentPage === 1) return <LoaderInCentalPosition />

  if (!appealsList || !totalCount)
    return (
      <div className={styles.appealsEmpty}>
        <EmptyInformationBlock
          title='Здесь будут ваши монтажи'
          Icon={Message}
        />
      </div>
    )

  return (
    <div className={styles.appeals}>
      <div className={styles.appeals__list}>
        {appealsList?.map(item => (
          <LkmAppeal
            data={item}
            key={item.id}
            handleOpen={() => onOpen(item)}
          />
        ))}
      </div>

      {appealsList.length < totalCount && (
        <Button
          onClick={setNextPage}
          className={styles.appeals__button}
          data-testid='lkm-appeals-load-more'
        >
          {isFetching ? <CircularProgress size={25} /> : 'Показать еще'}
        </Button>
      )}
    </div>
  )
}
